import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3568a1fb&scoped=true&"
import script from "./index.vue?vue&type=script&lang=tsx&"
export * from "./index.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3568a1fb",
  null
  
)

export default component.exports